import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { useLocationPagination } from '../../../../../Pagination'
import {
  IMPORT_LOG_FILTER_ALL,
  IMPORT_LOG_PAGE_SIZE,
} from '../../IntegrationsImportLog.constants'
import { getMockImportRuns } from '../../IntegrationsImportLog.mocks'
import {
  getImportLogReadKey,
  getIsImportLogReadCurrent,
} from '../../IntegrationsImportLog.utils'

// TODO: move to useTableLoader once `POST /api/v3/integration/import/runs/filter/` exists; until then the fixture is read here
export function useIntegrationsImportRuns() {
  const [source, setSource] = useState(IMPORT_LOG_FILTER_ALL)
  const [status, setStatus] = useState(IMPORT_LOG_FILTER_ALL)
  const [retryCount, setRetryCount] = useState(0)

  const { pagination, setPagination } = useLocationPagination()

  const { page } = pagination

  const [result, setResult] = useState(null)

  const readIdRef = useRef(0)

  const readKey = getImportLogReadKey([page, source, status, retryCount])

  function changePage(nextPage) {
    setPagination({ ...pagination, page: nextPage })
  }

  async function loadRuns() {
    readIdRef.current += 1

    const readId = readIdRef.current

    return getMockImportRuns({
      page,
      page_size: IMPORT_LOG_PAGE_SIZE,
      source,
      status,
    })
      .then(({ data }) => {
        if (getIsImportLogReadCurrent({ readId, readIdRef })) {
          setResult({ data, hasError: false, key: readKey })
          changePage(data.pagination.page)
        }
      })
      .catch(() => {
        if (getIsImportLogReadCurrent({ readId, readIdRef })) {
          setResult(prevResult => ({
            ...prevResult,
            hasError: true,
            key: readKey,
          }))
        }
      })
  }

  useEffect(() => {
    loadRuns()

    return () => {
      readIdRef.current += 1
    }
  }, [readKey])

  function handleSelectStatus(nextStatus) {
    changePage(1)
    setStatus(nextStatus)
  }

  function handleSelectSource(nextSource) {
    changePage(1)
    setSource(nextSource)
  }

  function handleSetPagination(nextPagination) {
    changePage(nextPagination.page)
  }

  function handleRetry() {
    setRetryCount(prevCount => prevCount + 1)
  }

  return {
    handleRetry,
    handleSelectSource,
    handleSelectStatus,
    handleSetPagination,
    hasError: Boolean(result?.hasError),
    isInitiated: Boolean(result),
    isLoading: result?.key !== readKey,
    items: result?.data?.items ?? EMPTY_LIST,
    pagination: {
      count: result?.data?.pagination?.count ?? 0,
      page,
      pageCount: result?.data?.pagination?.page_count ?? 0,
      pageSize: IMPORT_LOG_PAGE_SIZE,
    },
    source,
    status,
  }
}
